"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 *  This reducer create typical reducer for common type of actions { type, payload } only.
 */
var ui_1 = require("../actions/ui");
function default_1(state, action) {
    if (state === void 0) { state = {}; }
    switch (true) {
        case action.type.includes(ui_1.UPDATE_UI):
        case action.type.includes(ui_1.CLEAR_UI):
            return Object.assign({}, action.payload);
        default:
            return state;
    }
}
exports.default = default_1;
